// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"a5192251","417":"12daaecd","423":"9148bf2f","484":"e7ccd5ad","608":"67d9cee3","654":"8006ed09","663":"06cda7ec","867":"497433a1","921":"5a589069","968":"5539314a"}[chunkId] + ".chunk.js";
};